import type { A2HSStorage } from './interface';

export const STORE_NAME = 'A2HSStore';

export const initialState: A2HSStorage = {
    heading: {
        text: 'Install',
        fontFamily: 'Gill Sans',
        fontSize: 'min(8vmin, 28pt)',
        fontWeight: 500,
        color: '#000',
        visible: true,
    },
    subheading: {
        text: 'Install this app on your home screen for quick access?',
        fontFamily: 'Gill Sans',
        fontSize: 'min(5vmin, 18pt)',
        fontWeight: 500,
        color: '#000',
        visible: true,
    },
    appIconUrl: 'img/AppIcon192.png',
};
